{
  "_format": "hh-sol-artifact-1",
  "contractName": "Greeter",
  "sourceName": "contracts/Greeter.sol",
  "abi": [
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "address",
              "name": "contractAddress",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "merkleTreeDepth",
              "type": "uint256"
            }
          ],
          "internalType": "struct ISemaphoreVoting.Verifier[]",
          "name": "_verifiers",
          "type": "tuple[]"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "inputs": [],
      "name": "Semaphore__CallerIsNotThePollCoordinator",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "Semaphore__GroupAlreadyExists",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "Semaphore__GroupDoesNotExist",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "Semaphore__GroupIdIsNotLessThanSnarkScalarField",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "Semaphore__MerkleTreeDepthIsNotSupported",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "Semaphore__PollHasAlreadyBeenStarted",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "Semaphore__PollIsNotOngoing",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "Semaphore__YouAreUsingTheSameNillifierTwice",
      "type": "error"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "groupId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "merkleTreeDepth",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "zeroValue",
          "type": "uint256"
        }
      ],
      "name": "GroupCreated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "groupId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "index",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "identityCommitment",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "merkleTreeRoot",
          "type": "uint256"
        }
      ],
      "name": "MemberAdded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "groupId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "index",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "identityCommitment",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "merkleTreeRoot",
          "type": "uint256"
        }
      ],
      "name": "MemberRemoved",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "groupId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "index",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "identityCommitment",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "newIdentityCommitment",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "merkleTreeRoot",
          "type": "uint256"
        }
      ],
      "name": "MemberUpdated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "nullifierHash",
          "type": "uint256"
        }
      ],
      "name": "NullifierHashAdded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "pollId",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "coordinator",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "string",
          "name": "name",
          "type": "string"
        },
        {
          "indexed": false,
          "internalType": "string",
          "name": "decryption",
          "type": "string"
        },
        {
          "indexed": false,
          "internalType": "string[]",
          "name": "candidates",
          "type": "string[]"
        }
      ],
      "name": "PollCreated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "pollId",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "coordinator",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "decryptionKey",
          "type": "uint256"
        }
      ],
      "name": "PollEnded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "pollId",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "coordinator",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "encryptionKey",
          "type": "uint256"
        }
      ],
      "name": "PollStarted",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "pollId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "bytes32",
          "name": "vote",
          "type": "bytes32"
        }
      ],
      "name": "VoteAdded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "pollId",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "identityCommitment",
          "type": "uint256"
        }
      ],
      "name": "VoterAdded",
      "type": "event"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "pollId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "identityCommitment",
          "type": "uint256"
        }
      ],
      "name": "addVoter",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "ballotBox",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "candidates",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "pollId",
          "type": "uint256"
        }
      ],
      "name": "candidatesOfPoll",
      "outputs": [
        {
          "internalType": "string[]",
          "name": "",
          "type": "string[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "vote",
          "type": "bytes32"
        },
        {
          "internalType": "uint256",
          "name": "nullifierHash",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "merkleTreeRoot",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "pollId",
          "type": "uint256"
        },
        {
          "internalType": "uint256[8]",
          "name": "proof",
          "type": "uint256[8]"
        }
      ],
      "name": "castVote",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "coordinator",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "merkleTreeDepth",
          "type": "uint256"
        },
        {
          "internalType": "string",
          "name": "name",
          "type": "string"
        },
        {
          "internalType": "string",
          "name": "decryption",
          "type": "string"
        },
        {
          "internalType": "string[]",
          "name": "candidate",
          "type": "string[]"
        }
      ],
      "name": "createPoll",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "currentId",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "_value",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "pollId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "decryptionKey",
          "type": "uint256"
        }
      ],
      "name": "endPoll",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "pollId",
          "type": "uint256"
        }
      ],
      "name": "getGroupStatus",
      "outputs": [
        {
          "internalType": "enum ISemaphoreVoting.PollState",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "groupId",
          "type": "uint256"
        }
      ],
      "name": "getMerkleTreeDepth",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "groupId",
          "type": "uint256"
        }
      ],
      "name": "getMerkleTreeRoot",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "groupId",
          "type": "uint256"
        }
      ],
      "name": "getNumberOfMerkleTreeLeaves",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "pollId",
          "type": "uint256"
        }
      ],
      "name": "getResult",
      "outputs": [
        {
          "internalType": "bytes32[]",
          "name": "",
          "type": "bytes32[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "pollId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "encryptionKey",
          "type": "uint256"
        }
      ],
      "name": "startPoll",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
}
